<div class="modal-header b pb-0 px-5 pt-4">
  <h5 class="modal-title f-16">Search using Job Description</h5>
  <button data-testid="auto-app-job-description-modal-button-1" type="button" class="close py-3 font-weight-normal" data-dismiss="modal" aria-label="Close"
    (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body px-5">

  <div class="row" *ngIf="!enteredJobDescription || enteredJobDescription.length == 0">
    <div class="col">
      <label for="jd-upload" class="f-12"> Upload a JD </label>
      <div class="ats-upload-btn">
        <div *ngIf="!isUploadedFileCorrect" class="col ats--upload-cv text-center">
          <p class="text-webbtree-green">
            <i class="fas fa-cloud-upload-alt f-32"></i>
          </p>
          <div class="col">
            <p class="f-12 text-777" >
              Drag and drop file here or <label class="text-webbtree-green">
                click here to upload
              </label>
            </p>
            <p class="f-12 text-777" >
              Max file size: 5 MB
            </p>
          </div>
        </div>

        <input data-testid="auto-app-job-description-modal-input-1" *ngIf="!isUploadedFileCorrect" type="file" #document (change)="uploadFile($event)" 
          accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">

          <button data-testid="auto-app-job-description-modal-button-2" *ngIf="isUploadedFileCorrect" (click)="resetFormFields()"
            class="btn-trms-white">
            Remove file
          </button>

      </div>
    </div>
  </div>

  <div *ngIf="!enteredJobDescription || enteredJobDescription.length == 0" class="align-items-center">
    <p *ngIf="isUploadedFileCorrect && !specialCharaterError && !incorrectFileFormat" [ngClass]="['text-left','my-1']">
      <b>Uploaded file:</b> {{ uploadedFilename }}
    </p>
    <p *ngIf="specialCharaterError" [ngClass]="['text-left','my-1','text-danger']">
      Filename should not contain any special characters
    </p>
    <p *ngIf="incorrectFileFormat" [ngClass]="['text-left','my-1','text-danger']">
      File type should be .doc or .pdf or .docx or .txt
    </p>
    <p *ngIf="fileSizeLimitExceeded" [ngClass]="['text-left','my-1','text-danger']">
      File size cannot exceed 5 MB
    </p>
  </div>

    <h5 *ngIf="!enteredJobDescription || enteredJobDescription.length == 0" class="modal-title f-16 field-separator text-center">OR</h5>
  
  <div class="row">
    <div class="col">
      <label for="enter-jd" class="f-12"> Job Description </label>
      <div class="position-relative ">
        <textarea data-testid="auto-app-job-description-modal-textarea-1" [disabled]="disableManualJDInput" type="text" placeholder="Enter the job description" [(ngModel)]="enteredJobDescription"
          class="wc-textarea wc-form-control mb-2" rows="6"></textarea>
      </div>
    </div>
  </div>

  <div class="align-items-center">
    <p *ngIf="showJDNotAddedError" [ngClass]="['text-left','my-1','text-danger']">
      *Please upload or enter job description
    </p>
  </div>

</div>

<div class="modal-footer b pb-2">
  <span class="mx-auto d-flex p-3 justify-content-center">
      <button data-testid="auto-app-job-description-modal-button-3" type="button" class="btn-trms-medium m-auto" data-dismiss="modal"
      (click)="addJobDescription()"> Parse JD </button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button data-testid="auto-app-job-description-modal-button-4" *ngIf="enteredJobDescription && enteredJobDescription.length" class="btn-trms-white" (click)="clearEnteredJD()"> Clear text </button>
  </span>
</div>
